import { subscribeUser } from "../utilities/push";
import { createContext, useContext, useEffect, useReducer, useRef } from 'react';
import PropTypes from 'prop-types';
import { Provider, useDispatch, useSelector } from 'react-redux';
import store from "../store/index";
import { Me } from "../store/slice/usersSlice";
import { requestsCountAction } from 'store/slice/infoSlice';
export const AuthContext = createContext({ undefined });

const AuthInit = (props) => {
  const dispatch = useDispatch();

  const store = useSelector((store) => store.user)
  useEffect(() => {
    dispatch(Me())
  },[]);

  useEffect(() => {
    if (store.user?.id) {
      subscribeUser()
    }
  }, [store.user?.id])

  useEffect(() => {
    if (!store.user?.id) return;
    dispatch(requestsCountAction())
  }, [dispatch, store.user?.id])

  if (!store.loaded) {
    return (
      <div style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f0f2f5"
      }}>
        <div style={{
          border: "6px solid #e0e0e0",
          borderTop: "6px solid #3498db",
          borderRadius: "50%",
          width: "50px",
          height: "50px",
          animation: "spin 1s linear infinite"
        }} />
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>)
  }

  return (
    <AuthContext.Provider value={store}>
          {props.children}
    </AuthContext.Provider>
  )
}

export const AuthProvider = (props) => {
  const { children } = props;

  return (
      <AuthInit>
        {children}
      </AuthInit>
  )
};

AuthProvider.propTypes = {
  children: PropTypes.node
};

export const AuthConsumer = AuthContext.Consumer;

export const useAuthContext = () => useContext(AuthContext);
